module.exports = __webpack_public_path__ + "static/joost-666d4f023ee8028b9a9ff5da81840569.png";